module.exports = __webpack_public_path__ + "assets/Beta.abdd9e08ccb550946cf99b00b1b95def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Beta.png
// module id = 829
// module chunks = 0